<template>
    <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.986 5.5C11.9861 5.49947 10.0223 6.01452 8.29744 6.99196C6.57258 7.9694 5.14919 9.37379 4.17426 11.0601C3.19934 12.7464 2.70824 14.6534 2.75167 16.5843C2.79511 18.5152 3.37151 20.3998 4.42135 22.0436L3.5319 26.7502C3.50576 26.8918 3.51536 27.0374 3.55991 27.1746C3.60445 27.3119 3.68261 27.4367 3.78777 27.5386C3.87314 27.6189 3.97417 27.6822 4.08502 27.7246C4.19587 27.767 4.31432 27.7878 4.43353 27.7857H4.6163L10.5135 26.609C11.6271 27.0048 12.7998 27.2233 13.986 27.2562C16.9735 27.2562 19.8386 26.1101 21.9511 24.0701C24.0635 22.03 25.2503 19.2631 25.2503 16.3781C25.2503 13.493 24.0635 10.7262 21.9511 8.68612C19.8386 6.64608 16.9735 5.5 13.986 5.5Z"
            fill="#5625CC" />
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M14.3773 3.71094C14.7367 3.71094 15.028 4.00228 15.028 4.36167V8.30672C15.028 8.66611 14.7367 8.95745 14.3773 8.95745C14.0179 8.95745 13.7266 8.66611 13.7266 8.30672V4.36167C13.7266 4.00228 14.0179 3.71094 14.3773 3.71094Z"
              fill="#5625CC" />
        <path
            d="M16.3302 2.90336C16.3302 3.98153 15.4561 4.85556 14.378 4.85556C13.2998 4.85556 12.4258 3.98153 12.4258 2.90336C12.4258 1.8252 13.2998 0.951172 14.378 0.951172C15.4561 0.951172 16.3302 1.8252 16.3302 2.90336Z"
            fill="#5625CC" />
        <path
            d="M13.1013 14.2147C13.1013 15.1132 12.373 15.8415 11.4745 15.8415C10.576 15.8415 9.84766 15.1132 9.84766 14.2147C9.84766 13.3162 10.576 12.5879 11.4745 12.5879C12.373 12.5879 13.1013 13.3162 13.1013 14.2147Z"
            fill="white" />
        <path
            d="M20.4831 14.2147C20.4831 15.1132 19.7548 15.8415 18.8563 15.8415C17.9578 15.8415 17.2295 15.1132 17.2295 14.2147C17.2295 13.3162 17.9578 12.5879 18.8563 12.5879C19.7548 12.5879 20.4831 13.3162 20.4831 14.2147Z"
            fill="white" />
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M11.875 17.7676L12.4271 18.3198C13.8762 19.7694 16.2268 19.7693 17.6764 18.3197L18.2286 17.7676L19.3329 18.8719L18.7808 19.4241C16.7214 21.4834 13.3818 21.4839 11.3226 19.424L10.7705 18.8717L11.875 17.7676Z"
              fill="white" />
    </svg>
</template>
<script>
export default {
    name: "ChatbotFill",
};
</script>
<style lang="scss">
</style>